import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";

function TransactionSuccessfulPage() {
    const {state} = useLocation();

    let redirectionUrl = state != null ? state?.redirectionUrl : undefined;
    const paymentReference = state != null ? state?.paymentReference : undefined;
    const merchantName = state != null ? state?.shopName : undefined;

    let timeLeft = 10;

    const redirectUser = () => {
        if (redirectionUrl == undefined || redirectionUrl === '') {
            return;
        } else {
            const successRedirectionUrl = new URL(`${redirectionUrl}`);
            successRedirectionUrl.searchParams.set("payment_reference", paymentReference)

            window.location.replace(successRedirectionUrl);
        }
    }

    let downloadTimer = setInterval(function () {
        if (redirectionUrl == undefined || redirectionUrl === '') return;
        if (timeLeft <= 0) {
            clearInterval(downloadTimer);
            redirectUser()
        } else {
            document.getElementById("successCountdown").innerHTML = timeLeft;
        }
        timeLeft -= 1;
    }, 1000);

    return (<div className="flex flex-col items-center justify-center h-screen">

        <div className="mt-4 mb-2 mx-auto">
            <img
                src="/hellopay.svg"
                className="my-2 sm:mb-8 mx-auto w-auto h-[50px]"
                alt={"logo"}
            />
            <img
                src="/hellopaySuccessIcon.svg"
                className="mt-4 mb-2 mx-auto h-[200px] sm:h-[300px] w-auto"
                alt={"logo"}
            />
        </div>

        <div className="flex space-x-2 my-2 sm:mt-6
                        font-bold text-[32px] sm:text-[40px]">
            <div className="mr-1">Payment</div>
            <div className="text-[#8BCD38]">Successful</div>
        </div>

        <div className="align-center text-[#948F9F] text-xs sm:text-base">
            <div>Now you can continue shopping!</div>
        </div>

        {(redirectionUrl != undefined && redirectionUrl !== "") && <div>
            <button
                className="mt-8 mb-2 px-4 py-2 rounded-md flex justify-between items-center space-x-3 hover:shadow-xl disabled:shadow-none
                bg-gradient-to-r from-purple to-very_dark_grayish_violet disabled:opacity-50 text-sm text-white uppercase"
                onClick={(e) => {
                    const btn = e.currentTarget;
                    btn.disabled = true;
                    redirectUser();
                }}
            >
                <span className="text-xs sm:text-sm">Return to store</span>

                <div className="mx-auto flex items-center justify-center">
                    <div className="relative z-10 flex items-center overflow-hidden rounded-full p-[1.5px]">
                        <div
                            className="animate-rotate absolute inset-0 h-full rounded-full bg-[conic-gradient(transparent_180deg,#FFFFFF_20deg)]"
                        />
                        <div className="relative z-20 flex rounded-full bg-very_dark_grayish_violet">
                            <div id="successCountdown" className="sm:p-0.5 w-5 sm:w-7 h-5 sm:h-7"/>
                        </div>
                    </div>
                </div>
            </button>
        </div>}
    </div>);
}

export default TransactionSuccessfulPage;